import { getAllRequiredFields } from './getAllRequiredFields'
import { ContentStateProperty } from '../../../@types/types'
import { useGetFinalParsedValidationSchema } from '../validationService'

export const useIsRequiredProperty = (propertyName: ContentStateProperty): boolean => {
  const finalValidationSchema = useGetFinalParsedValidationSchema()
  const allMandatoryFields: string[] = getAllRequiredFields(finalValidationSchema)
  const foundField = allMandatoryFields.find((field) => field === propertyName)
  return !!foundField
}
